import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { environment } from '../../../environments/environment';
import { OrderStore } from './order.store';
import { OrderState } from '../models/order-state.model';

@Injectable({ providedIn: 'root' })
export class OrderQuery extends Query<OrderState> {
    public state$ = this.select();

    public order$ = this.select([
        'billingAddress',
        'contract',
        'payment',
        'insurants',
        'insuredObjects',
        'insurantsFamilyRelationship',
    ]);

    public productSlug$ = this.select((state: OrderState) => state.productSlug);

    public currentStep$ = this.select('currentStep');

    public completedSteps$ = this.select('completedSteps');

    public invalidSteps$ = this.select('invalidSteps');

    public tags$ = this.select((state: OrderState) => state.tags);

    public get productSlug(): string {
        return this.store.getValue().productSlug || '';
    }

    public constructor(protected store: OrderStore) {
        super(store);
        if (environment.debug) {
            this.subscribeForStateChanges();
        }
    }

    private subscribeForStateChanges(): void {
        /* eslint-disable-next-line no-console */
        this.state$.subscribe(console.info);
    }
}
